import axios from 'axios';

async function checkMember() {
  const body = document.querySelector('body');
  const isLoggedIn = body.dataset.loggedIn === 'true';

  if (!isLoggedIn) {
    return;
  }

  const openLoyaltyMember = await Shopify.functions.getMember();

  if (openLoyaltyMember) {
    Shopify.functions.showMemberSections(true);
    return;
  }

  await createMember();

  Shopify.functions.showMemberSections(true);
}

async function createMember() {
  const customer = window.customer;

  try {
    const shopifyCustomer = await axios.get(`https://intersportapi.netlify.app/.netlify/functions/getCustomer?id=${customer?.id}`);
    const { first_name, last_name, phone, note } = shopifyCustomer.data;

    const noteParts = note.split('\n');
    const labels = {};
    let phoneFromNote = null;

    noteParts.forEach((part) => {
      const [key, value] = part.split(': ');

      if (key === 'phone') {
        phoneFromNote = value;
        return;
      }

      labels[key?.trim()] = value?.trim();
    });

    const userData = {
      email: customer?.email,
      firstName: first_name,
      lastName: last_name,
      phone: phone || phoneFromNote || null,
      birthDate: '2000-01-11',
      agreement1: true,
      agreement2: true,
      labels: labels || [],
    };

    const url = 'https://intersportapi.netlify.app/.netlify/functions/createMember';

    await axios.post(url, userData);
  } catch (error) {
    console.log('🚀 ~ error:', error);
  }
}

checkMember();
